<app-question-card>
  <p question *ngIf="journeyType === FelloOfferJourneyType.IO">
    <ng-container *ngIf="leadType === AgentLeadType.HV; else IO"> Enter your information to view your full report. </ng-container>
    <ng-template #IO>
      How do we get in touch with you?
      <app-icon class="ml-1 c-pointer" (click)="openWhyDialog()" color="var(--color-primary)" fontWeight="100">info </app-icon>
    </ng-template>
  </p>
  <p question *ngIf="journeyType === FelloOfferJourneyType.LWF">
    <app-icon class="ml-1 c-pointer" (click)="openWhyDialog()" color="var(--color-primary)" fontWeight="100">info </app-icon>
    What is the best way to contact you?
  </p>

  <form input-options #loginForm="ngForm">
    <!--    <div class="box-c mb-20" *ngIf="journeyType === FelloOfferJourneyType.IO; else LWF_text">-->
    <!--      <p>After you confirm your home details, we'll email you a no obligation offer within 24 hours.</p>-->
    <!--    </div>-->
    <!--    <ng-template #LWF_text>-->
    <!--      <div class="box-c mb-20">-->
    <!--        <p>-->
    <!--          We'll assign an agent to you, and you can request a different one if you prefer. Our service is 100% free. With no obligation to-->
    <!--          move forward.-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </ng-template>-->

    <div class="form-field mb-3">
      <input
        type="email"
        placeholder="Email address"
        name="email"
        required
        [(ngModel)]="userEmail"
        libEmail
        (keyup.enter)="loginForm.valid && next()"
      />
    </div>
  </form>

  <p class="chat-answer" answer>{{ userEmail }} <br /></p>

  <button class="w-100 mt-3" input-options (click)="next()" [disabled]="loginForm?.invalid">Continue</button>
</app-question-card>
